import { type VideoProject, buildProject } from '@cinematic-engine/video-dsl';

export function createSampleProject(): VideoProject {
  return {
    version: '1.0',
    schemaVersion: 1,
    id: 'sample-project',
    metadata: {
      title: 'A Última Fronteira',
      language: 'pt-BR',
      description: 'Sample project demonstrating the Cinematic Engine DSL',
    },
    format: { preset: 'cinema-16-9', width: 1920, height: 1080, fps: 24 },
    style: { preset: 'cinematic' },
    assets: [
      {
        id: 'asset-bg',
        type: 'image',
        name: 'Space Background',
        source: { kind: 'generated' },
        metadata: { width: 1920, height: 1080 },
      },
      {
        id: 'asset-music',
        type: 'audio',
        name: 'Ambient Score',
        source: { kind: 'generated' },
        metadata: { duration: 12 },
      },
    ],
    scenes: [
      {
        id: 'scene-1',
        title: 'Opening',
        duration: 10,
        shots: [
          {
            id: 'shot-1',
            start: 0,
            duration: 5,
            purpose: 'Establishing shot of the frontier',
            emotion: 'wonder',
            energy: 0.3,
            camera: {
              type: 'perspective',
              position: { x: 0, y: 0, z: 5 },
              rotation: { x: 0, y: 0, z: 0 },
              target: { x: 0, y: 0, z: 0 },
              fov: 35,
              near: 0.1,
              far: 1000,
              movement: 'slow_push',
            },
            subjects: [{ assetId: 'asset-bg', usage: 'background' }],
            environment: [],
            effects: [
              { type: 'grain', intensity: 0.3 },
              { type: 'color-grade', intensity: 0.5 },
              { type: 'vignette', intensity: 0.35 },
            ],
            typography: [
              {
                text: 'A ÚLTIMA FRONTEIRA',
                style: 'title',
                animation: 'mask-reveal',
                animationDuration: 1.5,
                delay: 0,
              },
              {
                text: 'Onde as estrelas guardam seus segredos',
                style: 'subtitle',
                animation: 'fade',
                animationDuration: 1,
                delay: 1.5,
              },
            ],
            audio: [
              {
                assetId: 'asset-music',
                start: 0,
                duration: 5,
                gain: 0.8,
                track: 'music',
                fadeIn: 0.5,
                fadeOut: 0.5,
                loop: false,
              },
            ],
            transition: { type: 'fade', duration: 0.5 },
          },
          {
            id: 'shot-2',
            start: 5,
            duration: 5,
            purpose: 'Reveal of the destination',
            emotion: 'anticipation',
            energy: 0.5,
            camera: {
              type: 'perspective',
              position: { x: 0, y: 0, z: 3 },
              rotation: { x: 0, y: 0, z: 0 },
              target: { x: 0, y: 0, z: -2 },
              fov: 45,
              near: 0.1,
              far: 1000,
              movement: 'slow_pull',
            },
            subjects: [{ assetId: 'asset-bg', usage: 'background' }],
            environment: [],
            effects: [{ type: 'dof', intensity: 0.4 }],
            typography: [
              {
                text: 'CAPÍTULO UM',
                style: 'chapter',
                animation: 'tracking',
                animationDuration: 0.8,
                delay: 0,
              },
            ],
            audio: [
              {
                assetId: 'asset-music',
                start: 0,
                duration: 5,
                gain: 0.9,
                track: 'music',
                fadeIn: 0,
                fadeOut: 0,
                loop: false,
              },
            ],
            transition: { type: 'cut', duration: 0 },
          },
        ],
      },
    ],
    audio: {
      tracks: [
        { id: 'music-track', name: 'Music', kind: 'music', clips: [] },
        { id: 'voice-track', name: 'Voice', kind: 'voice', clips: [] },
      ],
    },
    responsive: [],
    output: {},
  };
}

export function buildSampleCompiledProject() {
  return buildProject(createSampleProject());
}
